import { CommonModule } from '@angular/common';
import { HttpClientModule } from '@angular/common/http';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { GoogleMapsModule } from '@angular/google-maps';
import { RouterModule } from '@angular/router';
import { NgbDateAdapter, NgbDateParserFormatter, NgbModule, NgbTimeAdapter } from '@ng-bootstrap/ng-bootstrap';
import { ZXingScannerModule } from '@zxing/ngx-scanner';
import { FileUploadModule } from 'ng2-file-upload';
import { ColorPickerModule } from 'ngx-color-picker';
import { NgxMaterialTimepickerModule } from 'ngx-material-timepicker';
import { PropertyItemGridComponent } from './Components/Shared/PropertyItemGridComponent';
import { AutofocusDirective } from './Directives/auto-focus.directive';
import { ECINgbDateParserFormatter, NgbDateStringAdapter } from './Directives/DateParser';
import { CallbackPipe } from './Directives/filterPipe';
import { FormatAddressPipe } from "./Directives/formatAddress";
import { DirectionsMapDirective } from './Directives/GmapDirections';
import { MapToIterable } from './Directives/keyValueFilter';
import { PhonePipe } from './Directives/PhoneDisplay';
import { ArraySortPipe } from "./Directives/sortPipe";
import { summaryNumberPipe } from './Directives/summaryNumber';
import { NgbTimeStringAdapter } from './Directives/TimeParser';
import { ServiceModule } from './Services/service.module';
import { SortService } from './Services/SortableStuff/sort.service';
import { SortableColumnComponent } from './Services/SortableStuff/sortable-column.component';
import { SortableTableDirective } from './Services/SortableStuff/sortable-table.directive';
import { InputMaskModule } from '@ngneat/input-mask';
import { RatingComponent } from './Components/3rdParty/Rating/ratingcomponent';
import { EditorModule } from '@tinymce/tinymce-angular';
import { safeHtmlPipe } from './Directives/safeHtml';
import { SortablejsModule } from 'ngx-sortablejs-ext';
import { LuxonModule } from 'luxon-angular';
import { CustomerInvoiceArbitraryItemEditComponent } from './Components/Shared/CustomerInvoiceArbitraryItemComponentEdit';
import { ScheduleEditComponent } from './Components/Shared/ScheduleEditComponent';
import { AddressEditComponent } from './Components/Shared/AddressEditComponent';
import { PropertyItemImageComponent } from './Components/Shared/PropertyItemImageComponent';
import { ImagePopUpComponent } from './Components/PopUps/ImagePopUpComponent';
import { MakePaymentPartialComponent } from './Components/Shared/MakePaymentComponent';
import { yesNoPipe } from './Directives/yesNoPipe';
import { yesBlankPipe } from './Directives/yesBlankPipe';
import { TextFieldModule } from '@angular/cdk/text-field';
import { ThumbnailDirective } from './Directives/uploadImagePreview';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { DateTimeToFormatHideMidnightPipe } from './Directives/LuxonHideMidnight';
import { MessageContentPopUpComponent } from './Components/PopUps/MessageContentPopUpComponent';
import { DeliveryZoneVisualEditComponent } from './Components/PopUps/DeliveryZoneVisualComponentEdit';
import { DeliveryZoneVisualPopUpComponent } from './Components/PopUps/DeliveryZoneVisualComponentPopUp';
import { PropertyItemMoveBulkComponent } from './Components/PopUps/PropertyItemMoveBulkComponent';
import { PropertyItemBulkComponent } from './Components/PopUps/PropertyItemBulkComponent';
import { writeBarcode, type WriterOptions } from "zxing-wasm/writer";
import { BarcodeComponent } from './Components/3rdParty/BarCode/BarCodeComponent';
@NgModule({
	imports: [
		FileUploadModule,
		CommonModule,
		ServiceModule,
		DragDropModule,
		EditorModule,
		NgxMaterialTimepickerModule,
		InputMaskModule,
		FormsModule,
		HttpClientModule,
		NgbModule,
		RouterModule,
		ColorPickerModule,
		ZXingScannerModule,
		GoogleMapsModule,
		SortablejsModule.forRoot({ animation: 150 }),
		LuxonModule,
		TextFieldModule
	],
	exports: [
		FileUploadModule,
		ServiceModule,
		DragDropModule,
		EditorModule,
		FormsModule,
		HttpClientModule,
		ColorPickerModule,
		RouterModule,
		NgxMaterialTimepickerModule,
		InputMaskModule,
		ZXingScannerModule,
		GoogleMapsModule,
		SortablejsModule,
		LuxonModule,
		TextFieldModule,

		yesNoPipe,
		yesBlankPipe,
		FormatAddressPipe,
		ArraySortPipe,
		NgbModule,
		MapToIterable,
		CallbackPipe,
		PhonePipe,
		summaryNumberPipe,
		SortableTableDirective,
		SortableColumnComponent,
		ThumbnailDirective,
		DirectionsMapDirective,
		RatingComponent,
		PropertyItemGridComponent,
		AddressEditComponent,
		PropertyItemImageComponent,
		ImagePopUpComponent,
		CustomerInvoiceArbitraryItemEditComponent,
		ScheduleEditComponent,
		MakePaymentPartialComponent,
		safeHtmlPipe,
		MessageContentPopUpComponent,
		DateTimeToFormatHideMidnightPipe,
		DeliveryZoneVisualEditComponent,
		DeliveryZoneVisualPopUpComponent,
		PropertyItemMoveBulkComponent,
		PropertyItemBulkComponent,
		BarcodeComponent
	],
	providers: [
		SortService,

	],
	declarations: [
		FormatAddressPipe,
		ArraySortPipe,
		MapToIterable,
		CallbackPipe,
		SortableTableDirective,
		SortableColumnComponent,
		PhonePipe,
		yesNoPipe,
		yesBlankPipe,
		AutofocusDirective,
		ThumbnailDirective,
		summaryNumberPipe,
		DirectionsMapDirective,
		RatingComponent,
		safeHtmlPipe,
		PropertyItemGridComponent,
		AddressEditComponent,
		PropertyItemImageComponent,
		ImagePopUpComponent,
		CustomerInvoiceArbitraryItemEditComponent,
		ScheduleEditComponent,
		MakePaymentPartialComponent,
		MessageContentPopUpComponent,
		DateTimeToFormatHideMidnightPipe,
		DeliveryZoneVisualEditComponent,
		DeliveryZoneVisualPopUpComponent,
		PropertyItemMoveBulkComponent,
		PropertyItemBulkComponent,
		BarcodeComponent
	],
})
export class LocalCommonModule {
	static forRoot() {
		return {
			ngModule: LocalCommonModule,
			providers: [
				{ provide: NgbDateParserFormatter, useClass: ECINgbDateParserFormatter },
				{ provide: NgbDateAdapter, useClass: NgbDateStringAdapter },
				{ provide: NgbTimeAdapter, useClass: NgbTimeStringAdapter },

			],
		}
	}
}
